import { useQuery, useMutation } from '@tanstack/react-query'
import { useContentSettingsStore } from '@/store'
import { ContentSettings } from '@/types/meta'

export const useContentSettings = () => {
  const { getContentSettings } = useContentSettingsStore()

  return useQuery({
    queryKey: ['contentSettings'],
    queryFn: () => getContentSettings(),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000
  })
}

export const useUpdateContentSettings = () => {
  const { updateContentSettings } = useContentSettingsStore()

  return useMutation({
    mutationFn: (data: ContentSettings) => updateContentSettings(data),
    throwOnError: false
  })
}
